import { InputDiv, Select } from '../../../styles/global'
import { ConfigDetails, Hint } from './styles'
import {
  ARRANGEMENT_LABELS,
  applyConductorChange,
  applyGroupingChange,
  getAllowedCases,
  getArrangements,
  getAvailableMethods,
  getUnsupportedMethods,
  summarizeConfig,
} from './conductorConfig'

const FALLBACK_INSULATIONS = ['PVC', 'EPR', 'XLPE']

// columnCount: coluna de capacidade usada (2 ou 3); loadedCount: condutores carregados considerados pela API.
export function ConductorFields({
  title,
  config,
  onChange,
  conductorOptions,
  groupingOptions,
  idPrefix,
  columnCount,
  loadedCount,
  children,
}) {
  const { conductor, grouping } = config
  const methods = getAvailableMethods(conductorOptions, columnCount)
  const insulations = conductorOptions?.insulations || FALLBACK_INSULATIONS
  const arrangements = getArrangements(conductorOptions, conductor.method, columnCount)
  const isUnsupported = getUnsupportedMethods(groupingOptions).includes(conductor.method)
  const allowedCases = getAllowedCases(groupingOptions, conductor.method)

  function changeConductor(patch) {
    onChange(applyConductorChange(config, patch, conductorOptions, groupingOptions, columnCount))
  }

  return (
    <ConfigDetails>
      <summary>
        {title}
        <small>{summarizeConfig(config)}</small>
      </summary>
      <InputDiv>
        <span>Isolação</span>
        <div>
          <Select
            style={{ marginLeft: '0' }}
            id={`${idPrefix}-insulation`}
            value={conductor.insulation}
            onChange={(event) => changeConductor({ insulation: event.target.value })}
          >
            {insulations.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </Select>
        </div>
      </InputDiv>
      <InputDiv>
        <span>Método de instalação</span>
        <div>
          <Select
            style={{ marginLeft: '0' }}
            id={`${idPrefix}-method`}
            value={conductor.method}
            onChange={(event) => changeConductor({ method: event.target.value })}
          >
            {methods.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </Select>
        </div>
      </InputDiv>
      <Hint style={{ marginBottom: '10px' }}>
        Condutores carregados: {loadedCount} (calculado automaticamente pela ligação, NBR 5410 tabela 46).
      </Hint>
      {arrangements.length > 0 && (
        <InputDiv>
          <span>Disposição dos cabos</span>
          <div>
            <Select
              style={{ marginLeft: '0' }}
              id={`${idPrefix}-arrangement`}
              value={conductor.arrangement || arrangements[0]}
              onChange={(event) => changeConductor({ arrangement: event.target.value })}
            >
              {arrangements.map((item) => (
                <option key={item} value={item}>
                  {ARRANGEMENT_LABELS[item] || item}
                </option>
              ))}
            </Select>
          </div>
        </InputDiv>
      )}
      {isUnsupported ? (
        <>
          <Hint>
            O fator de agrupamento da tabela 42 não é calculado automaticamente para o método {conductor.method}.
            Informe um fator manual compatível com a condição real.
          </Hint>
          <InputDiv>
            <span>Fator de agrupamento manual</span>
            <input
              type="number"
              min="0"
              step="0.01"
              value={config.groupFactor ?? 1}
              onChange={(event) => onChange({ ...config, groupFactor: event.target.value })}
            />
          </InputDiv>
        </>
      ) : (
        <>
          <InputDiv>
            <span>Caso de agrupamento (tabela 42)</span>
            <div>
              <Select
                style={{ marginLeft: '0' }}
                id={`${idPrefix}-case`}
                value={grouping?.reference}
                onChange={(event) => onChange(applyGroupingChange(config, { reference: Number(event.target.value) }))}
              >
                {allowedCases.length > 0 ? (
                  allowedCases.map((item) => (
                    <option key={item.reference} value={item.reference}>
                      {item.reference} - {item.name}
                    </option>
                  ))
                ) : (
                  <option value={grouping?.reference}>{grouping?.reference}</option>
                )}
              </Select>
            </div>
          </InputDiv>
          <InputDiv>
            <span>Circuitos agrupados (incluindo este)</span>
            <input
              type="number"
              min="1"
              step="1"
              value={grouping?.circuitCount ?? ''}
              onChange={(event) => onChange(applyGroupingChange(config, { circuitCount: event.target.value }))}
            />
          </InputDiv>
        </>
      )}
      {children}
    </ConfigDetails>
  )
}
